import { styled } from "styled-components";

import { $AssetModel } from "@atlassiansox/bxp-content-framework";
import { Anchor } from "@atlassiansox/bxp-content-framework";

import { colorCSS } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const ValueProp = styled.div<{
    $image?: $AssetModel;
    $appearance?: string;
}>`
    ${redundantCssFromKebab("position", "relative")}
    ${redundantCssFromKebab("padding-left", "4.5rem")}

    ${({ $image }) =>
        $image
            ? `
        background-image: url(${$image.url});
        background-repeat: no-repeat;
        background-position: 0.25rem top;
        background-size: 3rem auto;
    `
            : ""}

    ${({ $appearance }) =>
        $appearance !== "No padding" ? "padding-bottom: 2rem;" : ""}

    > svg {
        height: 2.5rem;
        left: 0.5rem;
        position: absolute;
        top: 0.375rem;
        width: 2.5rem;
    }

    code {
        background: ${colorCSS("trelloblue")};
        border-radius: 0.25rem;
        color: ${colorCSS("N0")};
        display: inline-block;
        font-family: inherit;
        font-size: 75%;
        margin-left: 2px;
        padding: 0.12rem 0.5rem 0.25rem;
        position: relative;
        top: -2px;
        vertical-align: baseline;
        white-space: nowrap;
    }

    p {
        margin-bottom: 0.75rem;
    }

    p:last-child {
        margin-bottom: 0;
    }

    ul {
        margin-top: 0.5rem;
        margin-bottom: 0.75rem;
        padding-left: 1.5rem;
    }

    ul:last-child {
        margin-bottom: 0;
    }

    li {
        margin-bottom: 0.25rem;
    }

    li:last-child {
        margin-bottom: 0;
    }
`;

//when an anchor, should not have link appearance
export const ValuePropLink = styled(Anchor)({
    "color": "inherit !important",
    "display": "block",
    "textDecoration": "none",
    "text-decoration": "none"
});
